import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPowerBIAccess, getPowerBiReportDetails } from '../services';

export const getReportDetails = createAsyncThunk(
  'powerBI/getReportDetails',
  async (params: any) => {
    const res = await getPowerBiReportDetails(params);
    return res.data;
  }
);

export const getPowerBIReportAccess = createAsyncThunk(
  'powerBI/getPowerBIReportAccess',
  async (data: any) => {
    const res = await getPowerBIAccess(data);
    return res.data;
  }
);
